module.exports = __webpack_public_path__ + "static/media/red-close-ic.e8485f85.svg";